import { render, staticRenderFns } from "./redoButtonOn.vue?vue&type=template&id=546a423f&"
import script from "./redoButtonOn.vue?vue&type=script&lang=ts&"
export * from "./redoButtonOn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports